module.exports = __webpack_public_path__ + "media/images/emoticons/d-point-f798e468e5bf99223b6b4a87a57568af.gif";